import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination, A11y, Autoplay, EffectCreative} from 'swiper';

import SecondImage from '../../../assets/annete-banner-mobile-2.webp';
import ThirdImage from '../../../assets/annete-banner-mobile-3.webp';
import FourthImage from '../../../assets/annete-banner-mobile-4.webp';
import FifthImage from '../../../assets/annete-banner-mobile-5.webp';
import SixthImage from '../../../assets/annete-banner-mobile-6.webp';
import SeventhImage from '../../../assets/annete-banner-mobile-7.webp';
import EighthImage from '../../../assets/annete-banner-mobile-8.webp';
import NinthImage from '../../../assets/annete-banner-mobile-9.webp';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import 'swiper/css/effect-creative';

const slideStyle = {display: 'flex', justifyContent: 'center'};
const imgStyle = {width: '100%', aspectRatio: '3 / 4'};

// Served from public/ (not webpack-processed) so its URL matches the
// <link rel="preload"> in public/index.html exactly.
const FirstImage = `${process.env.PUBLIC_URL}/annete-banner-mobile-1.webp`;

const slides = [
  {src: FirstImage, isFirst: true},
  {src: SecondImage},
  {src: ThirdImage},
  {src: FourthImage},
  {src: FifthImage},
  {src: SixthImage},
  {src: SeventhImage},
  {src: EighthImage},
  {src: NinthImage},
];

const MobileCarousel = () => {
  return (
    <Swiper
      modules={[Navigation, Pagination, A11y, Autoplay, EffectCreative]}
      spaceBetween={50}
      loop={true}
      slidesPerView={1}
      lazy={true}
      pagination={{
        clickable: true,
        dynamicBullets: true,
      }}
      autoplay={{delay: 3000}}
      grabCursor={true}
      effect={'creative'}
      creativeEffect={{
        prev: {
          shadow: true,
          translate: [0, 0, -400],
        },
        next: {
          translate: ['100%', 0, 0],
        },
      }}
    >
      {slides.map(({src, isFirst}, index) => (
        <SwiperSlide key={index} style={slideStyle}>
          <img
            src={src}
            alt={`Fotografía de pastelería Annete ${index + 1}`}
            width={390}
            height={520}
            // eslint-disable-next-line react/no-unknown-property
            fetchpriority={isFirst ? 'high' : undefined}
            loading={isFirst ? 'eager' : 'lazy'}
            style={imgStyle}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

MobileCarousel.propTypes = {};

export default MobileCarousel;
